/*
 * ============================================================
 * argile-finition-finder.js — modale multistep « Trouver la finition » (v2, data-driven)
 * ============================================================
 * Chargé par snippets/argile-finition-finder.liquid (rendu global).
 *
 * Toute la logique (arbre de décision + contenu des cartes finition) est dans
 * assets/argile-finition-finder-data.json, chargé en fetch au démarrage.
 *
 * Arbre :
 *   Q1 branche (Intérieur/Extérieur) → Q2 surface → [Q3 espace] → [Q4 sensibles]
 *   → [Q5 rendu] → carte résultat (1 finition) | écran impasse.
 *   Q3/Q4/Q5 sont CONDITIONNELLES (cf. JSON : `espaceQuestion`, `sensibles`, `rendus`).
 *   Une feuille porte `result` = acronyme finition OU "UNAVAILABLE".
 *
 * Le JS ne contient AUCUN libellé métier : il lit le JSON, affiche l'étape courante
 * et résout la feuille. Modifier le parcours = éditer le JSON, pas ce fichier.
 */
(function () {
  'use strict';

  var Q_KINDS = ['branch', 'surface', 'espace', 'sensible', 'rendu'];
  var RANK = { branch: 0, surface: 1, espace: 2, sensible: 3, rendu: 4 };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* i18n injecté par le Liquid (data-argile-ff-i18n). */
  var FF = {};

  function initFinder(root) {
    if (!root || root.dataset.wired) return;
    root.dataset.wired = '1';

    if (!FF.__loaded) {
      var cfgEl = root.querySelector('[data-argile-ff-i18n]');
      if (cfgEl) { try { var parsed = JSON.parse(cfgEl.textContent); for (var ck in parsed) FF[ck] = parsed[ck]; } catch (e) {} }
      FF.__loaded = true;
    }
    var LROOT = root.dataset.localeRoot || '/';
    function locURL(p) { return LROOT !== '/' ? LROOT + p : p; }

    var DATA = null;
    var answers = {};   // { branch, surface, espace, sensible, rendu(objet) }
    var cursor = 0;     // index de l'étape affichée dans la séquence dynamique
    var lastFocus = null;

    var stepQ = root.querySelector('[data-finder-step="question"]');
    var stepR = root.querySelector('[data-finder-step="result"]');
    var stepU = root.querySelector('[data-finder-step="unavailable"]');

    /* ---- Chargement des données + résolution des @références (helpers / _shared) ---- */
    var url = root.getAttribute('data-finder-data-url');
    var ready = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { DATA = resolveRefs(d); })
      .catch(function () { DATA = null; });

    function resolveRefs(d) {
      var refs = {};
      var k;
      for (k in (d.helpers || {})) refs[k] = d.helpers[k];
      for (k in (d._shared || {})) refs[k] = d._shared[k];
      function r(n) {
        if (typeof n === 'string') return (n.charAt(0) === '@') ? refs[n.slice(1)] : n;
        if (Array.isArray(n)) return n.map(r);
        if (n && typeof n === 'object') { var o = {}; for (var kk in n) o[kk] = r(n[kk]); return o; }
        return n;
      }
      return r(d);
    }

    /* ---- Accès au modèle selon les réponses ---- */
    function branchNode() { return DATA.branches[answers.branch]; }
    function findSurface() {
      var b = branchNode(); if (!b) return null;
      for (var i = 0; i < b.surfaces.length; i++) if (b.surfaces[i].value === answers.surface) return b.surfaces[i];
      return null;
    }
    function findEspace() {
      var s = findSurface(); if (!s || !s.espaces) return null;
      for (var i = 0; i < s.espaces.length; i++) if (s.espaces[i].value === answers.espace) return s.espaces[i];
      return null;
    }

    /* ---- Construction de la séquence dynamique d'étapes selon les réponses ---- */
    function pushRendu(steps, list) {
      steps.push({
        kind: 'rendu', key: 'rendu', style: 'cards',
        q: FF.qRendu,
        helper: answers.branch === 'ext' ? DATA.helpers.renduExt : DATA.helpers.rendu,
        options: list
      });
    }
    function terminal(res) {
      // Une feuille porte désormais result = { finitions: [codes classés], prepa: clé }.
      if (!res || res === 'UNAVAILABLE' || !res.finitions || !res.finitions.length) {
        return { kind: 'unavailable', key: 'unavailable' };
      }
      return { kind: 'result', key: 'result', result: res };
    }

    function buildSteps() {
      var steps = [];
      // Q1 — branche
      steps.push({
        kind: 'branch', key: 'branch', style: 'lettered',
        q: FF.qBranch, helper: DATA.helpers.q1,
        options: [
          { value: 'Intérieur', label: FF.interior, branch: 'int' },
          { value: 'Extérieur', label: FF.exterior, branch: 'ext' }
        ]
      });
      if (!answers.branch) return steps;
      var b = branchNode();

      // Q2 — surface
      steps.push({
        kind: 'surface', key: 'surface', style: 'lettered',
        q: b.surfaceQuestion.q, helper: b.surfaceQuestion.helper,
        options: b.surfaces.map(function (s) { return { value: s.value, label: s.labelLong || s.value, tag: s.tag }; })
      });
      if (!answers.surface) return steps;
      var surf = findSurface();
      if (!surf) return steps;

      // Surface terminale / rendu direct / espace
      if (surf.result) { steps.push(terminal(surf.result)); return steps; }
      if (surf.rendus) {
        pushRendu(steps, surf.rendus.any);
        if (!answers.rendu) return steps;
        steps.push(terminal(answers.rendu.result));
        return steps;
      }

      // Q3 — espace (ou Q3 bis pour Plafonds)
      var eq = surf.espaceQuestion;
      steps.push({
        kind: 'espace', key: 'espace', style: 'lettered',
        q: eq.q, helper: eq.helper,
        options: surf.espaces.map(function (e) { return { value: e.value, label: e.value, tag: e.tag }; })
      });
      if (!answers.espace) return steps;
      var esp = findEspace();
      if (!esp) return steps;

      if (esp.result) { steps.push(terminal(esp.result)); return steps; }

      if (esp.sensibles) {
        // Q4 — personnes sensibles
        steps.push({
          kind: 'sensible', key: 'sensible', style: 'bool',
          q: FF.qBiosource,
          helper: DATA.helpers.biosource,
          options: [{ value: 'Oui', label: FF.yes }, { value: 'Non', label: FF.no }]
        });
        if (!answers.sensible) return steps;
        var rkey = answers.sensible === 'Oui' ? 'oui' : 'non';
        pushRendu(steps, esp.rendus[rkey]);
      } else {
        pushRendu(steps, esp.rendus.any);
      }
      if (!answers.rendu) return steps;
      steps.push(terminal(answers.rendu.result));
      return steps;
    }

    function isAnswered(step) {
      if (!step) return false;
      return step.kind === 'rendu' ? !!answers.rendu : !!answers[step.key];
    }

    /* ---- Total prévisionnel d'étapes (pour « Étape n/total ») ---- */
    function deepestEspace(s) {
      var d = 3;
      (s.espaces || []).forEach(function (e) {
        var n = e.result ? 3 : (e.sensibles ? 5 : 4);
        if (n > d) d = n;
      });
      return d;
    }
    function predictTotal() {
      if (!answers.branch) return 5;
      if (answers.branch === 'ext') {
        if (!answers.surface) {
          // Profondeur réelle de la branche : 3 si une surface ajoute une étape « rendu », sinon 2.
          var be = branchNode();
          return (be && be.surfaces.some(function (s) { return s.rendus; })) ? 3 : 2;
        }
        var se = findSurface(); return se && se.rendus ? 3 : 2;
      }
      if (!answers.surface) return 5;
      var s = findSurface();
      if (!s) return 5;
      if (s.result) return 2;
      if (s.rendus) return 3;
      if (!answers.espace) return deepestEspace(s);
      var e = findEspace();
      if (!e) return deepestEspace(s);
      if (e.result) return 3;
      return e.sensibles ? 5 : 4;
    }

    /* ---- Tags de contexte (réponses des étapes ANTÉRIEURES ; toutes pour le final) ---- */
    function renderContext(container, currentStep) {
      var el = container.querySelector('[data-finder-context]');
      if (!el) return;
      var cr = currentStep && RANK[currentStep.kind] !== undefined ? RANK[currentStep.kind] : 99;
      var tags = [];
      if (answers.branch && RANK.branch < cr) tags.push(answers.branch === 'int' ? FF.interior : FF.exterior);
      if (answers.surface && RANK.surface < cr) { var s = findSurface(); tags.push(s ? s.tag : answers.surface); }
      if (answers.espace && RANK.espace < cr) { var e = findEspace(); tags.push(e ? e.tag : answers.espace); }
      if (answers.sensible && RANK.sensible < cr) tags.push(answers.sensible === 'Oui' ? FF.tagBiosource : FF.tagClassic);
      if (answers.rendu && RANK.rendu < cr && answers.rendu.tag) tags.push(answers.rendu.tag);
      el.innerHTML = tags.map(function (t) { return '<span class="argile-finder__ctx-tag">' + esc(t) + '</span>'; }).join('');
      el.hidden = tags.length === 0;
    }

    /* ---- Image de droite : hero de la page « Trouver la finition » si présent
       (suit l'éditeur en direct), sinon image globale du réglage de thème
       (data-finder-fallback-image), sinon marron uni ---- */
    function applyHeroImage() {
      var hero = document.querySelector('[data-finder-hero][data-finder-target="finition"] img.argile-finder-intro__img');
      var src = (hero && (hero.currentSrc || hero.src)) || root.dataset.finderFallbackImage || '';
      root.querySelectorAll('.argile-finder__media').forEach(function (m) {
        m.style.backgroundImage = src ? 'url("' + src + '")' : '';
      });
    }

    /* ---- Rendu d'une option ---- */
    function isOptionSelected(step, o) {
      if (step.kind === 'rendu') return !!(answers.rendu && answers.rendu.label === o.label);
      if (step.kind === 'branch') return answers.branch === o.branch;
      return answers[step.key] === o.value;
    }
    function buildOption(step, o, i) {
      var sel = isOptionSelected(step, o);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', sel ? 'true' : 'false');
      if (step.style === 'lettered') {
        btn.className = 'argile-finder__option' + (sel ? ' is-selected' : '');
        btn.innerHTML = '<span class="argile-finder__letter">' + String.fromCharCode(65 + i) + '</span><span>' + esc(o.label) + '</span>';
      } else if (step.style === 'bool') {
        btn.className = 'argile-finder__option argile-finder__option--bool' + (sel ? ' is-selected' : '');
        btn.innerHTML = '<span class="argile-finder__radio"></span><span>' + esc(o.label) + '</span>';
      } else { // cards
        btn.className = 'argile-finder__card-option' + (sel ? ' is-selected' : '');
        // Vignette : image portée par l'option (JSON) sinon visuel de rendu (réglage/placeholder) selon le label.
        var img = o.image || '';
        if (!img) {
          if (/satin/i.test(o.label)) img = root.dataset.renduImageSatin || '';
          else if (/mat/i.test(o.label)) img = root.dataset.renduImageMat || '';
        }
        var thumbStyle = img ? ' style="background-image:url(\'' + esc(img) + '\')"' : '';
        btn.innerHTML = '<span class="argile-finder__card-thumb" aria-hidden="true"' + thumbStyle + '></span>'
          + '<span class="argile-finder__card-text"><strong>' + esc(o.label) + '</strong></span>'
          + '<span class="argile-finder__card-check" aria-hidden="true">'
          + '<svg viewBox="0 0 24 24" focusable="false"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
          + '</span>';
      }
      btn.addEventListener('click', function () { selectOption(step, o); });
      return btn;
    }

    function selectOption(step, o) {
      if (step.kind === 'branch') {
        if (answers.branch !== o.branch) answers = {};
        answers.branch = o.branch;
      } else if (step.kind === 'surface') {
        if (answers.surface !== o.value) { delete answers.espace; delete answers.sensible; delete answers.rendu; }
        answers.surface = o.value;
      } else if (step.kind === 'espace') {
        if (answers.espace !== o.value) { delete answers.sensible; delete answers.rendu; }
        answers.espace = o.value;
      } else if (step.kind === 'sensible') {
        if (answers.sensible !== o.value) delete answers.rendu;
        answers.sensible = o.value;
      } else if (step.kind === 'rendu') {
        answers.rendu = o;
      }
      render(); // reste sur l'étape courante : surligne le choix + active « Suivant »
    }

    /* ---- Rendu d'une étape question ---- */
    function renderQuestion(step, steps) {
      stepQ.querySelector('[data-finder-q]').textContent = step.q;
      var hEl = stepQ.querySelector('[data-finder-helper]');
      hEl.textContent = step.helper || '';
      hEl.hidden = !step.helper;

      var opts = stepQ.querySelector('[data-finder-options]');
      opts.className = 'argile-finder__options argile-finder__options--' + step.style;
      opts.innerHTML = '';
      step.options.forEach(function (o, i) { opts.appendChild(buildOption(step, o, i)); });

      renderContext(stepQ, step);

      // Position = index RÉEL de l'étape affichée (les entrées 0..cursor sont toutes
      // des questions ; le terminal vient après). Pas le total de la séquence prédite,
      // qui grandit dès qu'on sélectionne une option.
      var pos = cursor + 1;
      var total = Math.max(pos, predictTotal());
      stepQ.querySelector('[data-finder-etape]').textContent = FF.stepPrefix + ' ' + pos + '/' + total;
      stepQ.querySelector('.argile-finder__progress-bar').style.width = (pos / total * 100) + '%';

      stepQ.querySelector('[data-finder-prev]').hidden = (step.kind === 'branch');
      stepQ.querySelector('[data-finder-next]').disabled = !isAnswered(step);
    }

    /* ---- Rendu de l'écran résultat : finitions classées + bloc préparation ---- */
    function spec(label, value, opts) {
      opts = opts || {};
      var info = opts.tip
        ? '<span class="argile-finder__rec-info" tabindex="0" role="note" aria-label="' + esc(label + ' : ' + opts.tip) + '">'
          + '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
          + '<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"></circle>'
          + '<path d="M12 11v5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"></path>'
          + '<circle cx="12" cy="7.7" r="1.15" fill="currentColor"></circle></svg>'
          + '<span class="argile-finder__rec-tip" role="tooltip">' + esc(opts.tip) + '</span></span>'
        : '';
      return '<div class="argile-finder__rec-spec' + (opts.wide ? ' argile-finder__rec-spec--wide' : '') + '">'
        + '<span class="argile-finder__rec-spec-label">' + esc(label) + info
        + '</span><span class="argile-finder__rec-spec-value">' + esc(value) + '</span></div>';
    }
    function badge(modifier, value) {
      return '<span class="argile-finder__rec-badge argile-finder__rec-badge--' + modifier + '">' + esc(value) + '</span>';
    }
    function renderCard(acr, isIdeal) {
      var f = DATA.finitions[acr];
      if (!f) return '';
      var R = DATA.result || {};
      var badges = '';
      if (f.gamme) badges += badge('gamme', f.gamme);
      if (f.rendu) badges += badge('rendu', f.rendu);
      // Ordre maquette : Brillance · Résistance (large) · COV. La classe est du
      // type « Classe 2 — Lavable… » : le préfixe passe en info-bulle (i), le reste
      // devient la valeur affichée.
      var specs = '';
      if (f.brillance) specs += spec('Brillance', f.brillance);
      if (f.classe) {
        var cl = f.classe.split('—');
        var tag = cl[0].trim();
        var val = cl.slice(1).join('—').trim() || tag;
        specs += spec(FF.resistance, val, { tip: val !== tag ? tag : '', wide: true });
      }
      if (f.cov) specs += spec('COV', f.cov);

      // Specs + description + alerte sont repliés derrière un accordéon (caret) :
      // la carte au repos montre seulement badges + titre + tagline.
      var moreBody = '';
      if (specs) moreBody += '<div class="argile-finder__rec-specs">' + specs + '</div>';
      if (f.desc) moreBody += '<p class="argile-finder__rec-desc">' + esc(f.desc) + '</p>';
      if (f.alerte) {
        // L'emoji ⚠️ éventuel du texte est retiré : on rend une icône sceau dédiée.
        var alertText = f.alerte.replace(/^[\s⚠⚡❗❕️]+/, '');
        moreBody += '<p class="argile-finder__rec-alert">'
          + '<span class="argile-finder__rec-alert-icon" aria-hidden="true">'
          + '<svg viewBox="0 0 22 22" fill="none" focusable="false">'
          + '<path d="M10.813 15.9643C11.0873 15.9643 11.3157 15.8748 11.498 15.6958C11.6802 15.5166 11.7713 15.2898 11.7713 15.0155C11.7713 14.7412 11.6807 14.5118 11.4998 14.3275C11.3188 14.1433 11.091 14.0513 10.8165 14.0513C10.5422 14.0513 10.3138 14.1432 10.1315 14.327C9.94933 14.511 9.85825 14.7402 9.85825 15.0145C9.85825 15.289 9.94875 15.5159 10.1298 15.6953C10.3108 15.8746 10.5385 15.9643 10.813 15.9643ZM10.8942 11.9958C11.1357 11.9958 11.3373 11.9139 11.499 11.7503C11.6607 11.5866 11.7415 11.3845 11.7415 11.144V6.42075C11.7415 6.18042 11.6592 5.97833 11.4945 5.8145C11.33 5.65083 11.1269 5.569 10.8853 5.569C10.6438 5.569 10.4422 5.65083 10.2805 5.8145C10.1188 5.97833 10.038 6.18042 10.038 6.42075V11.144C10.038 11.3845 10.1203 11.5866 10.285 11.7503C10.4495 11.9139 10.6526 11.9958 10.8942 11.9958ZM7.445 18.9643H4.3685C3.896 18.9643 3.494 18.7985 3.1625 18.467C2.831 18.1355 2.66525 17.7335 2.66525 17.261V14.199L0.48475 12.0083C0.314917 11.8383 0.191667 11.6506 0.115 11.4453C0.0383333 11.2401 0 11.0313 0 10.8188C0 10.6064 0.0383333 10.3963 0.115 10.1883C0.191667 9.98025 0.314917 9.79125 0.48475 9.62125L2.66525 7.4305V4.3685C2.66525 3.89433 2.831 3.49092 3.1625 3.15825C3.494 2.82558 3.896 2.65925 4.3685 2.65925H7.4305L9.62125 0.48475C9.79125 0.314917 9.98458 0.191668 10.2013 0.115001C10.4179 0.0383343 10.6325 0 10.845 0C11.0573 0 11.2662 0.0441679 11.4715 0.132501C11.6768 0.220668 11.8641 0.346417 12.0332 0.50975L14.1888 2.65925H17.261C17.7352 2.65925 18.1386 2.82558 18.4713 3.15825C18.8039 3.49092 18.9703 3.89433 18.9703 4.3685V7.4305L21.1448 9.62125C21.3146 9.79125 21.4378 9.97883 21.5145 10.184C21.5912 10.3892 21.6295 10.5979 21.6295 10.8103C21.6295 11.0226 21.5912 11.2328 21.5145 11.441C21.4378 11.6492 21.3146 11.8383 21.1448 12.0083L18.9703 14.199V17.261C18.9703 17.7335 18.8039 18.1355 18.4713 18.467C18.1386 18.7985 17.7352 18.9643 17.261 18.9643H14.1888L12.0332 21.0948C11.8641 21.2541 11.6768 21.3747 11.4713 21.4565C11.2657 21.5385 11.0567 21.5795 10.844 21.5795C10.6315 21.5795 10.4215 21.5385 10.214 21.4565C10.0067 21.3747 9.81742 21.2541 9.64625 21.0948L7.445 18.9643ZM8.1305 17.261L10.8398 19.8703L13.478 17.261H17.261V13.474L19.9263 10.8148L17.261 8.1495V4.3685H13.48L10.8398 1.70325L8.1555 4.3685H4.3685V8.1495L1.70925 10.8148L4.3685 13.474V17.261H8.1305Z" fill="currentColor"></path></svg>'
          + '</span><span>' + esc(alertText) + '</span></p>';
      }

      // En-tête toujours visible (= zone cliquable qui ouvre/replie l'accordéon).
      var head = (badges ? '<div class="argile-finder__rec-badges">' + badges + '</div>' : '')
        + '<h3 class="argile-finder__rec-title">' + esc(f.title) + '</h3>'
        + (f.tagline ? '<p class="argile-finder__rec-tagline">' + esc(f.tagline) + '</p>' : '');

      // Checkbox de sélection (hors du <summary> pour ne pas déclencher l'accordéon).
      var check = '<button type="button" class="argile-finder__rec-check" data-rec-select aria-pressed="false" aria-label="Choisir cette finition">'
        + '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12.5l5 5L20 6.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
        + '</button>';

      // Toute la carte (le <summary>) ouvre/replie le détail technique ; s'il n'y a
      // pas de détail, on garde le même conteneur sans <details>.
      var body = moreBody
        ? '<details class="argile-finder__rec-more">'
          + '<summary class="argile-finder__rec-summary">' + head
          + '<span class="argile-finder__rec-caret" aria-hidden="true"></span></summary>'
          + '<div class="argile-finder__rec-more-body">' + moreBody + '</div>'
          + '</details>'
        : '<div class="argile-finder__rec-summary argile-finder__rec-summary--static">' + head + '</div>';

      // Aside (bandeau vertical) : seulement pour la carte idéale. Les alternatives
      // n'ont pas de libellé (maquette : « c'est vide »).
      var aside = isIdeal
        ? '<span class="argile-finder__rec-aside">' + esc(R.idealBadge || 'Idéal') + '</span>'
        : '';
      return '<article class="argile-finder__rec ' + (isIdeal ? 'argile-finder__rec--ideal' : 'argile-finder__rec--alt') + '" data-code="' + esc(acr) + '">'
        + aside
        + check
        + body
        + '</article>';
    }
    function renderPrepa(key) {
      var p = DATA.prepas && DATA.prepas[key];
      // Cas « application directe » (aucune sous-couche nécessaire) : pas de bloc de
      // préparation du tout — la carte finition reste seule, conformément aux maquettes.
      if (!p || p.noPrep) return '';
      var R = DATA.result || {};
      // La carte est cliquable → collection Préparation (/collections/preparation) :
      // le client atterrit sur l'ensemble des produits de prépa. Nouvel onglet.
      // Pas de lien pour les prépas non-produit (isProduct:false) ou sans handle.
      var isLink = p.isProduct !== false && !!p.handle;
      var inner = '<p class="argile-finder__prepa-name">' + esc(p.name) + '</p>'
        + (p.note ? '<p class="argile-finder__prepa-note">' + esc(p.note) + '</p>' : '')
        + (isLink ? '<span class="argile-finder__prepa-cta">' + esc(FF.seePrep)
            + '<span class="argile-finder__prepa-cta-arrow">›</span></span>' : '');
      var card = isLink
        ? '<a class="argile-finder__prepa-card argile-finder__prepa-card--link" href="' + locURL('/collections/preparation') + '"'
          + ' target="_blank" rel="noopener noreferrer">' + inner + '</a>'
        : '<div class="argile-finder__prepa-card">' + inner + '</div>';
      return '<aside class="argile-finder__prepa">'
        + '<p class="argile-finder__prepa-heading">' + esc(R.prepaHeading || 'Produit de préparation recommandé') + '</p>'
        + card
        + '</aside>';
    }
    function renderResult(res) {
      var codes = (res && res.finitions || []).filter(function (c) { return DATA.finitions[c]; });
      if (!codes.length) { renderUnavailable(); return false; }
      renderContext(stepR, null);
      var html = codes.map(function (c, i) { return renderCard(c, i === 0); }).join('');
      html += renderPrepa(res.prepa);
      var results = stepR.querySelector('[data-finder-results]');
      results.innerHTML = html;
      // Carte idéale cochée par défaut → le CTA « Choisir cette finition » a une cible.
      var ideal = results.querySelector('.argile-finder__rec');
      if (ideal) setChosen(ideal);
      // CTA de validation : seulement en contexte fiche produit ; « Recommencer »
      // passe alors en secondaire pour laisser la priorité au choix de finition.
      var applyBtn = stepR.querySelector('[data-finition-apply]');
      var restart = stepR.querySelector('[data-finder-restart]');
      var inProduct = hasProductFinition();
      if (applyBtn) applyBtn.hidden = !inProduct;
      if (restart) {
        restart.classList.toggle('button', !inProduct);
        restart.classList.toggle('button-secondary', inProduct);
      }
      return true;
    }

    function renderUnavailable() {
      var u = DATA.unavailable || {};
      var t = stepU.querySelector('[data-finder-unavailable-title]');
      var d = stepU.querySelector('[data-finder-unavailable-desc]');
      if (t) t.textContent = u.title || '';
      if (d) d.textContent = u.desc || '';
      if (u.ctaPrimary) { var c1 = stepU.querySelector('[data-finder-unavailable-cta1]'); if (c1) c1.textContent = u.ctaPrimary.label; }
      if (u.ctaSecondary) {
        var c2 = stepU.querySelector('[data-finder-unavailable-cta2]');
        if (c2) { c2.textContent = u.ctaSecondary.label; c2.setAttribute('href', u.ctaSecondary.url); }
      }
    }

    function showOnly(el) {
      [stepQ, stepR, stepU].forEach(function (s) { s.hidden = (s !== el); s.classList.toggle('is-active', s === el); });
      var c = el.querySelector('.argile-finder__content');
      if (c) c.scrollTop = 0;
    }

    function render() {
      if (!DATA) return;
      var steps = buildSteps();
      if (cursor > steps.length - 1) cursor = steps.length - 1;
      if (cursor < 0) cursor = 0;
      var cur = steps[cursor];
      if (cur.kind === 'result') { if (renderResult(cur.result)) { showOnly(stepR); return; } cur = { kind: 'unavailable' }; }
      if (cur.kind === 'unavailable') { renderUnavailable(); showOnly(stepU); return; }
      renderQuestion(cur, steps);
      showOnly(stepQ);
    }

    /* ---- Ouverture / fermeture (drawer latéral : slide via .is-open) ---- */
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isInline = root.classList.contains('argile-finder--inline');
    var closeTimer = null;
    // Mode EN LIGNE : le finder vit dans une page dédiée, à côté d'un hero. On le
    // trouve pour le masquer/réafficher lors de l'ouverture/fermeture.
    function heroEl() {
      var page = root.closest('[data-finder-page]');
      return page ? page.querySelector('[data-finder-hero]') : null;
    }
    function open() {
      lastFocus = document.activeElement;
      answers = {};
      cursor = 0;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      applyHeroImage();
      // EN LIGNE : pas de pop-in — on masque le hero et le finder le remplace dans
      // le flux (pas d'overlay, pas de verrou de défilement).
      if (isInline) {
        var h = heroEl();
        if (h) h.hidden = true;
        root.hidden = false;
        ready.then(render);
        root.scrollIntoView({ block: 'start' });
        return;
      }
      root.hidden = false;
      document.documentElement.classList.add('argile-finder-open');
      // 2 frames : le navigateur peint d'abord l'état fermé (translateX(100%)),
      // puis .is-open déclenche la transition d'entrée. En une seule frame
      // (display:none → visible + is-open), la transition ne démarre pas.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-open'); });
      });
      ready.then(render);
      var close = root.querySelector('[data-finder-close]');
      if (close) close.focus();
    }
    function close() {
      // EN LIGNE : on masque le finder et on réaffiche le hero à sa place.
      if (isInline) {
        root.hidden = true;
        var h = heroEl();
        if (h) { h.hidden = false; h.scrollIntoView({ block: 'start' }); }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        return;
      }
      root.classList.remove('is-open');
      document.documentElement.classList.remove('argile-finder-open');
      var finish = function () { root.hidden = true; closeTimer = null; };
      // Anim de sortie seulement en mode panel (drawer) ; sinon fermeture immédiate.
      if (reduceMotion || !root.classList.contains('argile-finder--panel')) finish();
      else { if (closeTimer) clearTimeout(closeTimer); closeTimer = setTimeout(finish, 360); }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function restart() { answers = {}; cursor = 0; render(); }

    /* ---- Sélection (unique) d'une carte de recommandation ---- */
    function clearChosen() {
      stepR.querySelectorAll('.argile-finder__rec.is-chosen').forEach(function (r) {
        r.classList.remove('is-chosen');
        var b = r.querySelector('[data-rec-select]');
        if (b) b.setAttribute('aria-pressed', 'false');
      });
      clearUnavailNotes();
    }
    function setChosen(rec) {
      clearChosen();
      rec.classList.add('is-chosen');
      var b = rec.querySelector('[data-rec-select]');
      if (b) b.setAttribute('aria-pressed', 'true');
    }

    /* ---- Pont vers la fiche produit ----
       « Choisir cette finition » applique la carte cochée au <select data-finition>
       de la page (via argile-product.js qui écoute l'événement). Événement annulable :
       si la finition n'existe pas pour la teinte affichée, le handler fait
       preventDefault → dispatchEvent renvoie false → on montre une note en panel et
       on renvoie false (panel maintenu). Renvoie true si appliqué (→ on ferme). */
    function hasProductFinition() {
      return !!document.querySelector('[data-argile-product] [data-finition]');
    }
    function applyToProduct(rec) {
      clearUnavailNotes();
      var code = rec && rec.getAttribute('data-code');
      var f = code && DATA.finitions[code];
      if (!f) return false;
      var ev;
      try {
        ev = new CustomEvent('argile:finition-chosen', {
          cancelable: true,
          detail: { code: code, name: f.title || '' },
        });
      } catch (e) { return false; }
      if (document.dispatchEvent(ev) === false) {
        var note = document.createElement('p');
        note.className = 'argile-finder__rec-unavail';
        note.textContent = FF.notOffered;
        rec.appendChild(note);
        return false;
      }
      return true;
    }
    function clearUnavailNotes() {
      stepR.querySelectorAll('.argile-finder__rec-unavail').forEach(function (n) { n.remove(); });
    }

    /* ---- Navigation (délégation) ---- */
    root.addEventListener('click', function (e) {
      // Checkbox : bascule la sélection (cocher / décocher).
      var selBtn = e.target.closest('[data-rec-select]');
      if (selBtn) {
        var recC = selBtn.closest('.argile-finder__rec');
        if (recC) { recC.classList.contains('is-chosen') ? clearChosen() : setChosen(recC); }
        return;
      }
      // Ouvrir l'accordéon (clic sur la carte) coche aussi la case.
      var summ = e.target.closest('.argile-finder__rec-summary');
      if (summ) {
        var recS = summ.closest('.argile-finder__rec');
        var det = summ.closest('details.argile-finder__rec-more');
        // Accordéon exclusif : si cette carte va s'ouvrir, on referme les autres.
        if (det && !det.open) {
          stepR.querySelectorAll('details.argile-finder__rec-more[open]').forEach(function (d) {
            if (d !== det) d.open = false;
          });
        }
        if (recS && !recS.classList.contains('is-chosen')) setChosen(recS);
        // pas de return : le <details> s'ouvre/se ferme nativement
      }
      if (e.target.closest('[data-finition-apply]')) {
        var pick = stepR.querySelector('.argile-finder__rec.is-chosen') || stepR.querySelector('.argile-finder__rec');
        if (pick && applyToProduct(pick)) close();
        return;
      }
      if (e.target.closest('[data-finder-restart]')) { restart(); return; }
      if (e.target.closest('[data-finder-next]')) {
        var steps = buildSteps();
        var idx = Math.min(cursor, steps.length - 1);
        if (isAnswered(steps[idx]) && idx < steps.length - 1) { cursor = idx + 1; render(); }
        return;
      }
      if (e.target.closest('[data-finder-prev]')) {
        if (cursor > 0) { cursor -= 1; render(); }
        return;
      }
    });

    root.querySelectorAll('[data-finder-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

    root._argileOpen = open;
  }

  function openFinder() {
    var root = document.querySelector('[data-argile-finder]');
    if (root && root._argileOpen) root._argileOpen();
  }

  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-finition-finder-open], a[href="#finition-finder"]');
    if (!trig) return;
    e.preventDefault();
    openFinder();
  });

  function init() { document.querySelectorAll('[data-argile-finder]').forEach(initFinder); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
